export default "__VITE_ASSET__DPVw$osa__"